import { Component, Prop, Provide, Vue } from 'vue-property-decorator';

@Component
export default class ToolTip extends Vue {
    @Prop() public text!: string
    @Prop() public id!: string
    public getPopupContainer() {
        return document.getElementById(this.id)
    }
}